var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.3333H17.5",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66665 6.98334H3.33333C2.875 6.98334 2.5 7.35834 2.5 7.81667V15C2.5 15.4583 2.875 15.8333 3.33333 15.8333H4.66665C5.12498 15.8333 5.49998 15.4583 5.49998 15V7.81667C5.49998 7.35834 5.12498 6.98334 4.66665 6.98334Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 4.32498H9.33333C8.875 4.32498 8.5 4.69998 8.5 5.15832V15C8.5 15.4583 8.875 15.8333 9.33333 15.8333H10.6666C11.125 15.8333 11.5 15.4583 11.5 15V5.15832C11.5 4.69998 11.125 4.32498 10.6666 4.32498Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 1.66666H15.3333C14.875 1.66666 14.5 2.04166 14.5 2.49999V15C14.5 15.4583 14.875 15.8333 15.3333 15.8333H16.6666C17.125 15.8333 17.5 15.4583 17.5 15V2.49999C17.5 2.04166 17.125 1.66666 16.6666 1.66666Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenew);
export default __webpack_public_path__ + "static/media/revenew.fda261fb3254eb76d2b6c612f4d71434.svg";
export { ForwardRef as ReactComponent };